import {Form, Modal,  App,  Row, Col, Space   } from 'antd'
import { ASSETS_APPLICATION_BASE } from '../../config/api'
import React, { useEffect,useState } from 'react'
import classes from './costInvoice.module.css'
import { useCbpdjUpdateSaveMutation, useCbpdjUpdateQuery } from '../../store/DianShangYeWuApi';
import Icon from '../../cpn/Icon';
import CostListWithId from '../../document/cost/CostListWithId'
import ReportDeptSelect from '../../system/dept/DeptSelect'
import OCRTextArea from '../../cpn/OCRTextArea'
import UploadPic from '../../cpn/UploadPic'
import DocumentRule from '../../cpn/DocumentRule'
import Asterisk from '../../cpn/Asterisk'   
import CostInvoiceDel from './CostInvoiceDel'
function CostInvoiceEdit(props) {
    const { message } = App.useApp();
    const [open,setOpen] = React.useState(false);
    const [info,setInfo] = React.useState({
        'cbpdj_qy_id': '',
        'cbpdj_qy_name': '',
        'cbpdj_uid': '',
        'cbpdj_uname': '',
        'cbpdj_kh_id': '',
        'cbpdj_kh_name': '',
        'cbpdj_state': '',
        'cbpdj_image_file': '',
        'cbpdj_image_name': '',
        'cbpdj_id': '',
        'cbpdj_amount': '',
        'cbpdj_content': '',
        'cbpdj_bm_id': '',
        'cbpdj_bm_name': '',
        'cbpdj_ddzc_id': ''
    })
    const {data, isSuccess} = useCbpdjUpdateQuery({cbpdj_id:props.cbpdj_id},{skip:!open,refetchOnMountOrArgChange:1});
    const [form] = Form.useForm();
    const [updateSave] = useCbpdjUpdateSaveMutation();  
    const [defaultFileList, setDefaultFileList] = useState([]);
    
    useEffect(() => {
        if(isSuccess && data.Status === 'success'){
            setInfo({
                'cbpdj_qy_id': data.Result.cbpdj_qy_id, 
                'cbpdj_qy_name': data.Result.cbpdj_qy_name,
                'cbpdj_uid': data.Result.cbpdj_uid,
                'cbpdj_uname': data.Result.cbpdj_uname,
                'cbpdj_ctime': data.Result.cbpdj_ctime,
                'cbpdj_kh_id': data.Result.cbpdj_kh_id,
                'cbpdj_kh_name': data.Result.cbpdj_kh_name,
                'cbpdj_state': data.Result.cbpdj_state,
                'cbpdj_image_file': data.Result.cbpdj_image_file,
                'cbpdj_image_name': data.Result.cbpdj_image_name,
                'cbpdj_id': data.Result.cbpdj_id,
                'cbpdj_amount': data.Result.cbpdj_amount,
                'cbpdj_content': data.Result.cbpdj_content,
                'cbpdj_bm_id': data.Result.cbpdj_bm_id,
                'cbpdj_bm_name': data.Result.cbpdj_bm_name,
                'cbpdj_ddzc_id': data.Result.cbpdj_ddzc_id
            });
            setDefaultFileList(Array.isArray(data.Result.cbpdj_image_name) ? data.Result.cbpdj_image_name.filter(Boolean) : []);
            const imageNameArray = Array.isArray(data.Result.cbpdj_image_name) 
            ? data.Result.cbpdj_image_name.filter(Boolean)
            : (data.Result.cbpdj_image_name ? [data.Result.cbpdj_image_name] : []);
            const imageFileArray = Array.isArray(data.Result.cbpdj_image_file)
                ? data.Result.cbpdj_image_file.filter(Boolean)
                : (data.Result.cbpdj_image_file ? [data.Result.cbpdj_image_file] : []);

            const fileListForForm = imageNameArray.map((serverFileName, i) => {
                // 确保 URL 是完整路径
                // 根据 setupProxy.js，/api 代理到 fxapi.zzddww.com，用于访问图片
                let fullUrl = serverFileName;
                if (serverFileName.startsWith('http://')) {
                    // 完整 URL，直接使用
                    fullUrl = serverFileName;
                } else if (serverFileName.startsWith('/')) {
                    // 已经是相对路径，检查是否需要添加 /api 前缀
                    if (!serverFileName.startsWith('/api/') && !serverFileName.startsWith('/NeiZhangApi/')) {
                        fullUrl = `/api${serverFileName}`;
                    } else {
                        fullUrl = serverFileName;
                    }
                } else {
                    // 只是文件名，使用 /api/assets/images/application/ 路径
                    fullUrl = `${ASSETS_APPLICATION_BASE}/${serverFileName}`;
                }
                
                // 获取显示名称
                const displayName = imageFileArray[i] || undefined;
                
                return {
                    uid: `file-${i}-${serverFileName}`,
                    name: displayName || serverFileName || `文件${i + 1}`,
                    status: 'done',
                    url: fullUrl,
                    response: {
                        Result: serverFileName // 保存服务器文件名用于提交
                    }
                };
            });       
            form.setFieldsValue({
                'cbpdj_qy_id': data.Result.cbpdj_qy_id, 
                'cbpdj_qy_name': data.Result.cbpdj_qy_name,
                'cbpdj_uid': data.Result.cbpdj_uid,
                'cbpdj_uname': data.Result.cbpdj_uname,
                'cbpdj_kh_id': data.Result.cbpdj_kh_id,
                'cbpdj_kh_name': data.Result.cbpdj_kh_name,
                'cbpdj_state': data.Result.cbpdj_state,
                'cbpdj_image_file': fileListForForm,
                'cbpdj_image_name': imageNameArray,
                'cbpdj_id': data.Result.cbpdj_id,
                'cbpdj_amount': data.Result.cbpdj_amount,
                'cbpdj_content': data.Result.cbpdj_content,
                'cbpdj_bm_id': data.Result.cbpdj_bm_id,
                'cbpdj_bm_name': data.Result.cbpdj_bm_name,
                'cbpdj_ddzc_id': data.Result.cbpdj_ddzc_id
            })

        }
        
    }, [data, isSuccess,form])    

     return (
        <>
            <a onClick={() => {setOpen(true)}}>{props.cbpdj_kh_name}</a>
            <Modal
                open={open} 
                onCancel={() => {setOpen(false)}}
                width={1330}
                form={form}
                footer={null}
            >
                <Form
                    form={form}
                    className={classes.form}
                    labelCol={{ span: 4 }}
                    wrapperCol={{ span: 20 }}
                >
                    <Row style={{width:"1280px"}}>
                        <Col span={4} className={classes.row_top_left} style={{borderTop:'3px solid #339900',borderLeft:'3px solid #339900'}}></Col>
                        <Col span={16} className={classes.row_top_middle} style={{color:'#339900',borderTop:'3px solid #339900'}}>成本票登记</Col>
                        <Col span={4} className={classes.row_top_right} style={{borderTop:'3px solid #339900',borderRight:'3px solid #339900'}}></Col>
                         {/* 第一行 */}
                        <Col span={2} className={classes.col_top_label} style={{borderLeft:'3px solid #339900',color:'#339900'}}><Asterisk color='red'/> 付款单号</Col>
                        <Col span={6}  className={classes.col_top_input}>
                            <CostListWithId
                                id={info.cbpdj_ddzc_id}
                                qy_id={props.qy_id}
                                qy_name={props.qy_name}
                                yh_id={props.yh_id}
                                yh_name={props.yh_name}
                            />
                        </Col>  
                        <Col span={2} className={classes.col_top_label} ><Asterisk color='red'/> 成本票金额</Col>
                        <Col span={6}  className={classes.col_top_input} >
                            <span >￥</span>{Number(info.cbpdj_amount).toLocaleString('zh-CN', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            })}
                        </Col>  
                        <Col span={2}  className={classes.col_top_label} ><Asterisk color='red'/> 部门</Col>
                        <Col span={6}  className={classes.col_right_input}  style={{borderRight:'3px solid #339900'}}>
                            <ReportDeptSelect
                                yh_id={props.yh_id}
                                wrapperCol={{span:24}}
                                placeholder='请选择部门'
                                qy_id={props.qy_id}
                                onChange={(e,f) => {
                                    setInfo(prevState => ({ ...prevState, cbpdj_bm_id: e, cbpdj_bm_name: f }))
                                }}
                                name="cbpdj_bm_name"
                                defaultId={props.dsbzd_bm_id ? String(props.dsbzd_bm_id) : undefined}
                                style={{ width: '100%' }}
                                formStyle={{marginBottom: 0,width: '100%'}}
                            />
                        </Col> 
                        {/* 第二行 */}
                        <Col span={2}  className={classes.col_middle_label} style={{borderLeft:'3px solid #339900'}}><Asterisk color='red'/> 客户</Col>
                        <Col span={6}  className={classes.col_middle_input}>
                           {info.cbpdj_kh_name}
                        </Col>
                        <Col span={2}  className={classes.col_middle_label}><Asterisk color='red'/> 上传成本票</Col>
                        <Col span={14}  className={classes.col_middle_input} style={{borderRight:'3px solid #339900'}}>
                            <UploadPic
                                name='cbpdj_image'
                                onChange={(e,f) => {
                                    setInfo(prevState => ({ ...prevState, cbpdj_image_file: e, cbpdj_image_name: f }))
                                }}
                                maxCount={5}
                                style={{ width: '100%' }}
                                formStyle={{marginBottom: 0,width: '100%'}}
                                defaultFileList={defaultFileList}
                            />
                        </Col>
                        {/* 第三行 */}
                        <Col span={2}  className={classes.col_middle_label} style={{borderLeft:'3px solid #339900',borderBottom:'3px solid #339900'}}> 备注</Col>
                        <Col span={6}  className={classes.col_middle_input} style={{borderBottom:'3px solid #339900'}}>
                            <Form.Item name='cbpdj_content' noStyle>
                                <OCRTextArea
                                    value={info.cbpdj_content}
                                    onChange={(e) => {
                                        setInfo(prevState => ({ ...prevState, cbpdj_content: e.target.value }))
                                    }}
                                    language="chi_sim"
                                />
                            </Form.Item>
                        </Col>
                        <Col span={2}  className={classes.col_middle_label} style={{borderBottom:'3px solid #339900'}}>提交记录</Col>
                        <Col span={6}  className={classes.col_middle_input} style={{borderBottom:'3px solid #339900'}}>{info.cbpdj_uname} {info.cbpdj_ctime}</Col> 
                        <Col span={2} className={classes.col_middle_label} style={{borderBottom:'3px solid #339900'}}>编号</Col>
                        <Col span={6}  className={classes.col_middle_right_input} style={{borderRight:'3px solid #339900',borderBottom:'3px solid #339900'}}>{info.cbpdj_id}</Col>    
                                                               
                    </Row>   
                    <Row>
                        <Col span={24} style={{textAlign: 'right',paddingTop: '10px',display:'flex',justifyContent:'space-between'}}>
                            <DocumentRule/>
                            <Space size={20}>
                                <Icon 
                                    key='submit' 
                                    type='save' 
                                    onClick={() => {
                                        if(info.cbpdj_amount === ''){
                                            message.error('请输入金额');
                                            return;
                                        }
                                        if(info.cbpdj_kh_id === ''){
                                            message.error('请选择客户');
                                            return;
                                        } 
                                        if(info.cbpdj_bm_id === ''){
                                            message.error('请选择部门');
                                            return;
                                        }        
                                        if(info.cbpdj_image_file === ''){
                                            message.error('请上传成本票');
                                            return;
                                        }
                                        updateSave({
                                            'cbpdj_qy_id': info.cbpdj_qy_id,
                                            'cbpdj_qy_name': info.cbpdj_qy_name,
                                            'cbpdj_uid': info.cbpdj_uid,
                                            'cbpdj_uname': info.cbpdj_uname,
                                            'cbpdj_kh_id': info.cbpdj_kh_id,
                                            'cbpdj_kh_name': info.cbpdj_kh_name,
                                            'cbpdj_state': info.cbpdj_state,
                                            'cbpdj_image_file': info.cbpdj_image_file,
                                            'cbpdj_image_name': info.cbpdj_image_name,
                                            'cbpdj_id': info.cbpdj_id,
                                            'cbpdj_amount': info.cbpdj_amount,
                                            'cbpdj_content': info.cbpdj_content,
                                            'cbpdj_bm_id': info.cbpdj_bm_id,
                                            'cbpdj_bm_name': info.cbpdj_bm_name,
                                            'cbpdj_ddzc_id': info.cbpdj_ddzc_id                
                                        }).then(res => {
                                            if(res.data.Status==='success'){
                                                setOpen(false);
                                                message.success('修改成功');
                                                form.resetFields();  
                                            }else{
                                                message.error('修改失败！' + res.data.Message);
                                            }
                                        })     
                                    }}
                                />
                               
                                {props.cbpdj_state === '1' && <CostInvoiceDel cbpdj_id={props.cbpdj_id} />}
                               
                            </Space>
                        </Col>
                    </Row>
                </Form>
            </Modal>

        </>
    )
}

export default CostInvoiceEdit